import { useState, type InputHTMLAttributes } from "react";
import { cn } from "../lib/utils";

interface FloatingInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "placeholder"> {
  label: string;
  error?: string;
  containerClassName?: string;
}

export function FloatingInput({
  label,
  error,
  id,
  className,
  containerClassName,
  value,
  defaultValue,
  onChange,
  onFocus,
  onBlur,
  ...props
}: FloatingInputProps) {
  const [focused, setFocused] = useState(false);
  const [internalVal, setInternalVal] = useState<string>(String(defaultValue ?? ""));
  const isControlled = value !== undefined;
  const currentVal = isControlled ? value : internalVal;
  const filled = String(currentVal ?? "").length > 0;
  const inputId = id ?? `fi-${label.toLowerCase().replace(/\s+/g, "-")}`;

  return (
    <div className={cn("floating-input-root", containerClassName)}>
      <div className={cn("floating-input-wrap", focused && "floating-input-focused", error && "floating-input-error")}>
        <input
          id={inputId}
          className={cn("floating-input", className)}
          value={currentVal}
          onChange={e => {
            if (!isControlled) setInternalVal(e.target.value);
            onChange?.(e);
          }}
          onFocus={e => { setFocused(true); onFocus?.(e); }}
          onBlur={e => { setFocused(false); onBlur?.(e); }}
          placeholder=""
          {...props}
        />
        <label htmlFor={inputId} className={cn("floating-label", (focused || filled) && "floating-label-up")}>
          {label}
        </label>
      </div>
      {error && <p className="floating-input-error-msg">{error}</p>}
    </div>
  );
}
